export enum FormType {
  LeadCapture = 0,
  Newsletter = 1,
  ContactUs = 2,
  RequestDemo = 3,
  RequestQuote = 4,
  WebinarRegistration = 5,
  EventRegistration = 6,
  Feedback = 7,
  SupportRequest = 8,
  Custom = 9,
}

export enum FormFieldType {
  Text = 0,
  Email = 1,
  Phone = 2,
  Number = 3,
  TextArea = 4,
  Checkbox = 5,
  CheckboxGroup = 6,
  RadioGroup = 7,
  Dropdown = 8,
  Date = 9,
  FileUpload = 10,
  Hidden = 11,
}

export interface LeadFormField {
  id: string;
  formId?: string;
  label: string;
  type: FormFieldType;
  placeholder?: string;
  helpText?: string;
  required: boolean;
  options?: string[];
  displayOrder?: number;
}

export interface LeadForm {
  id: string;

  // brandingId: string;
  description: string;

  name: string;
  slug: string;
  formType: FormType;

  headerTitle: string;
  headerDescription: string;

  submitButtonText: string;
  successMessage: string;

  disclaimer?: string;
  privacyPolicyUrl?: string;

  primaryColor: string;
  secondaryColor: string;
  buttonColor: string;
  accentColor: string;

  backgroundImageUrl?: string;

  isActive: boolean;
  isPublic: boolean;

  updatedAt?: string;

  fields: LeadFormField[];
}

export type LeadFormInput = Omit<LeadForm, 'id' | 'updatedAt' | 'fields'>;
export type LeadFormFieldInput = Omit<LeadFormField, 'id' | 'formId' | 'displayOrder'>;

export interface FormFieldApiInput {
  label: string;
  placeholder: string;
  helpText: string;

  fieldType: FormFieldType;
  isRequired: boolean;

  defaultValue: string;

  displayOrder: number;

  optionsJson: string;

  minLength: number | null;
  maxLength: number | null;
}

export interface LeadFormFieldApi {
  id: string;
  formId: string;

  label: string;
  placeholder: string;
  helpText: string;

  fieldType: FormFieldType;
  isRequired: boolean;

  defaultValue: string;

  displayOrder: number;

  optionsJson: string;

  minLength: number | null;
  maxLength: number | null;
}

export interface LeadFormApi
  extends Omit<LeadForm, 'fields'> {
  fields: LeadFormFieldApi[];
}

export interface FormSubmission {
  id: string;
  formId: string;
  visitorIp: string;
  submittedDate: string;
  submissionJson: string;
  source: string;
  referrer: string;
}